import { useQuery } from '@tanstack/react-query';
import * as api from './api';

const ROOT_KEY = 'locales';

export function useActiveLocales() {
  return useQuery({
    queryKey: [ROOT_KEY, 'list', { activeOnly: true }] as const,
    queryFn: () => api.listLocales({ activeOnly: true }),
    staleTime: 60 * 60 * 1000, // locales are deploy-time data; refetch sparingly
  });
}
